import React from "react";
import { FiTrash, FiUser, FiMail, FiPhone, FiBriefcase, FiLayers } from "react-icons/fi";
import Button from "../../../../app/components/Button";

const ContactsClient = ({ onOpenAccess, contactsList, onDelete = () => {} }) => {
  const renderDepartamentos = (departamento) => {
  if (!departamento) return '';
  
  if (Array.isArray(departamento)) {
    const labels = departamento
      .map((d) => {
        if (typeof d === 'string') return d;
        if (d && typeof d === 'object') return d.label;
        return '';
      })
      .filter((label) => label && label.trim() !== '');
    
    return labels.length ? labels.join(', ') : '';
  }

  if (typeof departamento === 'object' && departamento.label) {
    return departamento.label;
  }

  return departamento;
};



  return (
    <div>
      <Button
        variant="primary"
        onClick={onOpenAccess}
        className="w-full"
      >
        Adicionar contato
      </Button>

      {contactsList.length === 0 ? (
        <div className="text-center text-gray-500 text-sm mt-6">
          <span className="font-medium">Nenhum contato cadastrado ainda.</span> <br />
          Adicione um contato para começar.
        </div>
      ) : (
        contactsList.map((item) => (
          <div
            key={item.id}
            className="relative border mt-8 pl-3 rounded-br-2xl rounded-tr-2xl rounded-tl-2xl pb-4"
          >
            <button
              type="button"
              className="absolute -top-1 -right-1 bg-white p-[0.09rem] text-red-500 text-sm"
              onClick={() => onDelete(item)}
            >
              <FiTrash />
            </button>

            <div className="flex items-center mt-4 gap-2">
              <FiUser />
              <h3>Nome</h3>
            </div>
            <p className="text-gray-400 mt-1">{item.nome}</p>

            <div className="flex items-center mt-4 gap-2">
              <FiBriefcase />
              <h3>Cargo</h3>
            </div>
            <p className="text-gray-400 mt-1">{item.cargo}</p>

            <div className="flex items-center mt-4 gap-2">
              <FiLayers />
              <h3>Departamento</h3>
            </div>
            <p className="text-gray-400 mt-1">{renderDepartamentos(item.departamento)}</p>

            <div className="flex items-center mt-4 gap-2">
              <FiMail />
              <h3>E-mail</h3>
            </div>
            <p className="text-gray-400 mt-1">{item.email}</p>

            <div className="flex items-center mt-4 gap-2">
              <FiPhone />
              <h3>Telefone</h3>
            </div>
            <p className="text-gray-400 mt-1">{item.telefone}</p>
          </div>
        ))
      )}
    </div>
  );
};

export default ContactsClient;
